import { useState } from "react";
import SC from "./style";
import { Button } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { InputField } from "components";

const RemoveFromProjectComponent = (props) => {
  const {
    setOpenDeleteView,
    openDeleteView,
    handleDelete = () => {},
    handleArchive = () => {},
    title = "",
    firstButtontext = "Cancel",
    messageData = "Are you sure you want to remove user from the Project?",
  } = props;

  const handleArchiveAction = () => {
    handleArchive();
  };

  const handleDeleteAction = (e) => {
    e.preventDefault();
    handleDelete();
    handleArchive();
  };

  return (
    openDeleteView && (
      <BulkActionView
        padding="10px 15px 5px 15px"
        fontSize="13px"
        // sx={{
        //   minWidth: "550px",
        // }}
        title={title}
        handleCloseModal={() => {
          handleArchiveAction();
        }}
        openModal={openDeleteView}
        renderBodyConditionally={() => (
          <SC.Container>
            <SC.WarningContainer>
              <SC.WarningIcon />
              <SC.WarningMessage>
                Removing This user will revoke their access to the project and
                its data.
              </SC.WarningMessage>
            </SC.WarningContainer>

            <SC.MessageDataContainer>
              <SC.MessageData>{messageData}</SC.MessageData>
            </SC.MessageDataContainer>

            <SC.ButtonContiner>
              <Button
                caption={firstButtontext}
                onClick={handleArchiveAction}
                fontSize="12px"
                style={{
                  marginBottom: 8,
                  background: theme.colors.cancelButton,
                  color: theme.colors.white,
                  minWidth: "90px",
                  borderRadius: "3px",
                  height: "30px",
                }}
              />
              <Button
                caption="Remove User"
                onClick={handleDeleteAction}
                fontSize="12px"
                color="white"
                style={{
                  marginBottom: 8,
                  background: "#f05455",
                  color: theme.colors.white,
                  minWidth: "90px",
                  borderRadius: "3px",
                  height: "30px",
                  cursor: "pointer",
                }}
              />
            </SC.ButtonContiner>
          </SC.Container>
        )}
      />
    )
  );
};

export default RemoveFromProjectComponent;
